const Actions = {
  player: {
    MoveLeft: "MoveLeft",
    MoveRight: "MoveRight",
    Jump: "Jump",
    Duck: "Duck",
    Cancel: "Cancel"
  }
};
export default Actions;